import { useMemo } from "react";
import { useWindowSize } from "@/hooks/useWindowSize";
import SectionLink from "./components/SectionLink";

const Home = () => {
  const { width, height } = useWindowSize();

  const containerDimmensions = useMemo(() => {
    if (!width || !height) {
      return {
        width: "520px",
        height: "250px",
      };
    }
    let screenWidth = "";
    let screenHeight = "";
    if (height > width) {
      screenWidth = `${width - 40}px`;
      screenHeight = `${(width - 60) / 2}px`;
    } else {
      screenWidth = `${height - 40}px`;
      screenHeight = `${(height - 60) / 2}px`;
    }
    return {
      width: screenWidth,
      height: screenHeight,
    };
  }, [width, height]);

  return (
    <div
      data-testid="Home"
      className="flex flex-row justify-center items-center min-h-fulldpx w-screen bg-ib-pt-color-neutral-100"
    >
      <div
        style={containerDimmensions}
        className="flex flex-row m-4 gap-x-5 min-w-[192px] min-h-[86px]"
      >
        <SectionLink linkTo="capture" />
        <SectionLink linkTo="admin" />
      </div>
    </div>
  );
};

export default Home;
